import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import CalendarIcon from '@/assets/icons/Calender.svg';

const MonthPicker = () => {
  const [currentDate, setCurrentDate] = useState(new Date());

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const handlePreviousMonth = () => {
    setCurrentDate((prev) => {
      const newDate = new Date(prev);
      newDate.setMonth(prev.getMonth() - 1);
      return newDate;
    });
  };

  const handleNextMonth = () => {
    setCurrentDate((prev) => {
      const newDate = new Date(prev);
      newDate.setMonth(prev.getMonth() + 1);
      return newDate;
    });
  };

  return (
    <div className=" flex items-center justify-center gap-3 p-3   text-jen-content-secondary bg-white rounded-lg border border-jen-border-primary w-fit">
      <button onClick={handlePreviousMonth} className=" hover:text-gray-900 transition-colors">
        <ChevronLeft size={16} />
      </button>

      <div className="flex justify-center items-center gap-2  w-[123px] lg:w-[160px]">
        <CalendarIcon fillColor="currentColor" />
        <span className="font-[400] text-center">
          {months[currentDate.getMonth()]} {currentDate.getFullYear()}
        </span>
      </div>

      <button onClick={handleNextMonth} className=" hover:text-gray-900 transition-colors">
        <ChevronRight size={16} />
      </button>
    </div>
  );
};

export default MonthPicker;
